import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { BusinessUnit, BusinessUnitCreateUpdate } from '#models';

@Injectable({
  providedIn: 'root',
})
export class BusinessUnitService {
  httpClient = inject(HttpClient);

  getBusinessUnitById(buId: number): Observable<BusinessUnit> {
    return this.httpClient.get<BusinessUnit>(environment.apiUrl + '/business-units/' + buId);
  }

  getAll(): Observable<BusinessUnit[]> {
    const url = environment.apiUrl + '/business-units';
    return this.httpClient.get<BusinessUnit[]>(url);
  }

  getBusinessUnitsListCurrentuser(): Observable<BusinessUnit[]> {
    const url = environment.apiUrl + '/business-units/current';
    return this.httpClient.get<BusinessUnit[]>(url);
  }

  addBusinessUnit(payload: BusinessUnitCreateUpdate) {
    return this.httpClient.post(environment.apiUrl + '/business-units', payload);
  }

  editBusinessUnit(businessUnitId: number, payload: BusinessUnitCreateUpdate) {
    return this.httpClient.put(environment.apiUrl + '/business-units/' + businessUnitId, payload);
  }
}
